import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class PredictionWidgetTabClickEvent extends ClickEvent {
  gameId: Number;
  status: Number;
  athleteId: Number;
  sportTypeId: Number;
  tabName: String;
  source: String;

  constructor(params) {
    super('', 'tab_click', 'prediction');

    this.gameId = params.gameId;
    this.status = params.status;
    this.athleteId = params.athleteId;
    this.sportTypeId = params.sportTypeId;
    this.tabName = params.tabName;
    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.sportTypeId = this.sportTypeId;
    properties.athleteId = this.athleteId;
    properties.tabName = this.tabName;
    properties.source = this.source;

    return properties;
  }
}